import { GenerateReportRequest } from 'libs/end-to-end/src/generate-report';
import { z } from 'zod';

export type GenerateReportFn = (
  request: GenerateReportRequest,
  onStarted?: (reportId: string) => void,
  onFinished?: (
    reportId: string,
    status: 'success' | 'failure',
    presignedUrl: string | null,
  ) => void,
) => void;

export const PendingReportInfo = z.object({
  reportId: z.string(),
  organizationId: z.string(),
  databaseId: z.string(),
  databaseRevisionId: z.string(),
  status: z.enum(['pending', 'processing', 'success', 'failure']),
  presignedUrl: z.string().nullable(),
});

export type PendingReportInfo = z.infer<typeof PendingReportInfo>;
